import { ExternalProvider } from '@ethersproject/providers';

declare global {
  interface Window {
    gala: ExternalProvider & { isGala: boolean };
  }
}

export const waitForGalaProvider = async (): Promise<
  (ExternalProvider & { isGala: boolean }) | undefined
> => {
  const maxRetries = 10;
  let retries = 0;

  while (typeof window.gala === 'undefined' && retries < maxRetries) {
    await new Promise(res => setTimeout(res, 100)); // poll every 100ms
    retries++;
  }

  if (window.gala) {
    window.gala.isGala = true;
    return window.gala;
  }
};
